var _ellipse, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPursewallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 244,
    viewBox: "0 0 246 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    cx: 123,
    cy: 122,
    rx: 122.492,
    ry: 122,
    fill: "#F4CDE0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7490_62011)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0119 80.5117H195.221C198.094 80.5117 200.444 82.8948 200.444 85.8081V179.168C200.444 182.081 198.094 184.464 195.221 184.464H52.0119C49.139 184.464 46.7891 182.081 46.7891 179.168V85.8081C46.7891 82.8948 49.139 80.5117 52.0119 80.5117Z",
    fill: "#5B2E4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0695 85.9346H189.279C192.152 85.9346 194.502 88.3176 194.502 91.231V184.591C194.502 187.504 192.152 189.887 189.279 189.887H46.0695C43.1966 189.887 40.8467 187.504 40.8467 184.591V91.231C40.8467 88.3176 43.1966 85.9346 46.0695 85.9346Z",
    fill: "#5B2E4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.7061 85.9334L159.121 57.9966C160.623 57.4001 162.333 58.1596 162.92 59.6824L173.025 85.8749L88.7061 85.9324V85.9334Z",
    fill: "#FBE0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.1152 85.9348L141.741 54.3434C143.441 53.6692 145.374 54.5275 146.038 56.2498L157.466 85.8687L62.1162 85.9339L62.1152 85.9348Z",
    fill: "#5B2E4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.037 125.026H201.734C203.615 125.026 205.154 126.588 205.154 128.495V148.11C205.154 149.587 203.963 150.795 202.507 150.795H167.038C160.049 150.795 154.332 144.997 154.332 137.91C154.332 130.823 160.049 125.025 167.038 125.025L167.037 125.026Z",
    fill: "#FBE0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.406 131.197C170.062 131.197 173.024 134.203 173.024 137.91C173.024 141.617 170.061 144.622 166.406 144.622C162.75 144.622 159.786 141.617 159.786 137.91C159.786 134.203 162.75 131.197 166.406 131.197Z",
    fill: "#5B2E4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8652 172.763H185.241V173.774H47.8652V172.763Z",
    fill: "#FBE0CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7822 86.0136L134.95 58.5717C136.426 57.9867 138.106 58.7318 138.683 60.2278L148.609 85.957L65.7822 86.0136Z",
    fill: "#FBE0CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7490_62011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 164.306,
    height: 135.774,
    fill: "white",
    transform: "translate(40.8467 54.1133)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPursewallet);
export default __webpack_public_path__ + "static/media/pursewallet.2ab87ba9e02c2c550a332afe81a1f50a.svg";
export { ForwardRef as ReactComponent };